import React, { Fragment } from 'react';
import { TableRow, TableCell, TextField, IconButton, Tooltip, InputAdornment } from '@material-ui/core';
import NumericLabel from 'react-pretty-numbers';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { fieldDateFormat, backendDateFormat, displayDateFormatShort } from '../../../constants';
import { getCurrencyFormat } from '../../../utils_v2';
import { regexConstants } from '../../../constants/regEx';
export default function CreditDebitList({invoice_item, mode, onFieldChange}) {
  return(
    <TableRow hover tabIndex={-1}>
      <TableCell style={{width:'180px'}}>
        { mode === 'view' ? invoice_item.description:
          <TextField
            id="description"
            fullWidth
            margin="normal"
            value={invoice_item.description}
            InputLabelProps={{shrink: true}}
            inputProps={{ maxLength: 255 }}
            // multiline
            // rows="4"
            onChange={(e) => onFieldChange(e, 'description', e.target.value)}
          />
        }
      </TableCell>
      <TableCell>
        { mode === 'view' ? invoice_item.rate_per_unit ? <NumericLabel params={getCurrencyFormat()}>{invoice_item.rate_per_unit}</NumericLabel>:'--':
          <TextField
            id="rate_per_unit"
            fullWidth
            margin="normal"
            value={invoice_item.rate_per_unit}
            InputLabelProps={{shrink: true}}
            inputProps={{ maxLength: 10 }}
            onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'rate_per_unit', e.target.value):e.preventDefault()}}
          />
        }
      </TableCell>
      <TableCell>
        { mode === 'view' ? invoice_item.sub_total ? <NumericLabel params={getCurrencyFormat({shortFormat:false})}>{invoice_item.sub_total}</NumericLabel>:'--':
          <TextField
            id="sub_total"
            fullWidth
            margin="normal"
            value={invoice_item.sub_total}
            InputLabelProps={{shrink: true}}
            InputProps={{
              startAdornment: <InputAdornment position="start"><span style={{fontSize:'13px'}}>US$</span></InputAdornment>,
            }}
            onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'sub_total', e.target.value): e.preventDefault()}}
          />
        }
      </TableCell>
    </TableRow>
  )
}

